module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8FJ5Q"))).then(() => module.bundle.root('d0iPb'));